var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.requestLoading),expression:"requestLoading"}],style:({
    width: _vm.width,
  }),attrs:{"value":_vm.value,"multiple":_vm.multiple,"filterable":"","clearable":"","placeholder":"请选择商品分类"},on:{"input":_vm.inputtt,"change":_vm.changeHanlder}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d5c98d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommodityCategoryAvailableSelect.vue
// module id = null
// module chunks = 